module.exports = __webpack_public_path__ + "img/close.79f74ae9.svg";